import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';
import { wsGetAll, wsFindBy } from 'services/WService.js';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

export default WithApp(function ModalCuotaProvider(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;

  const [dataImport, setDataImport] = useState({});
  const [incentivos, setIncentivos] = useState([]);
  const [zonas, setZonas] = useState([]);
  const [mesas, setMesas] = useState([]);
  const [sellers, setSellers] = useState([]);
  const [grupoIncentivos, setGrupoIncentivos] = useState([]);

  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);


  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listIncentivos() {
    let response = await wsGetAll('sale/tipo-incentivo');
    if (response.success) setIncentivos(response.data);
  }
  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZonas(response.data);
  }
  async function listMesas() {
    let response = await wsFindBy('base/bureau', {base_zone_id: dataChanging.base_zone_id, state: 'A', delete_at: null});
    if (response.success) setMesas(response.data);
  }

  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);

  useEffect(() => {
    if (dataImport?.success) {
      console.log("Importación exitosa", dataImport);
      setDataChanging((prev) => ({
        ...prev,
        tipo_incentivo_id: null,
      }));
      setBPartnerSelect({
        success: dataImport.success,
        customers: dataImport.data.map((item) => {
          return {
            tipo_incentivo_code: item.INCENTIVO_CODE,
            mecanica: item.MECANICA,
            fec_corte: item.DIA_CORTE,
          };
        }),
      });
    } else if (dataImport?.success === false) {
      console.log("Importación fallida", dataImport);
      setBPartnerSelect(undefined);
    }
  }, [dataImport]);

  useEffect(() => {
    if (bPartnerSelect?.tipo_incentivo_id) {
      setDataChanging((prev) => ({
        ...prev,
        tipo_incentivo_id: bPartnerSelect?.tipo_incentivo_id || '',
      }));
    }
  }, [bPartnerSelect]);

  useEffect(() => {
    if (customerPortfolioB.open) {
      if (!customerPortfolioB.id) {listIncentivos();listZones();};
      setDataChanging(customerPortfolioB);
    }
  }, [customerPortfolioB.open]);

  useEffect(() => {
    if (dataChanging.tipo_incentivo_id) {
      setDataChanging(prev => ({
        ...prev,
        mecanica: null,
        fec_corte: null,
      }));
    }
  }, [dataChanging.tipo_incentivo_id]);
  useEffect(() => {
    if (dataChanging.base_bureau_id) {
      setDataChanging(prev => ({
        ...prev,
        base_seller_id: null,
      }));
      setSellers([]);
    }
  }, [dataChanging.base_bureau_id]);

  useEffect(() => {
    if (dataChanging.base_zone_id) {
      setMesas([]);
      listMesas();
    }
  }, [dataChanging.base_zone_id])

  return (
    <>
      <Modal
        title={`Nueva cuota de vendedor`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity={
          dataChanging.tipo_incentivo_id
            ? 'sale/mecanica-venta'
            : 'sale/mecanica-venta/multiple'
        }
        dataForce={
          dataChanging.tipo_incentivo_id
            ? {
              tipo_incentivo_id: dataChanging.tipo_incentivo_id,
              fec_corte: dataChanging.fec_corte,
              }
            : {
                tipo_incentivo_id: cuota.valueSearch?.tipo_incentivo_id,
                customers: bPartnerSelect?.customers,
                force: 'N'
              }
        }
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="periodo"
          margin="normal"
          defaultValue={moment(cuota.valueSearch?.Periodo).format('YYYY-MM') || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <span style={{ display: 'flex', alignItems: 'flex-end' }}>
          <Autocomplete
            disableClearable
            options={incentivos}
            getOptionLabel={(item) => `${item.description}`}
            renderInput={(params) => (
              <TextField {...params} label="Incentivos" margin="normal" fullWidth />
            )}
            onChange={(e, item) => {handleChange('tipo_incentivo_id', item?.id); setDataImport(null);}}
            value={incentivos.find((incentivo) => incentivo.id === dataChanging.tipo_incentivo_id) || null}
            style={{ flexGrow: 1, marginRight: '10px' }}
          />
          <ImportExcel
            setDataImport={setDataImport}
            btnColor="success"
            validDuplicate={['INCENTIVO_CODE','MECANICA']}
            sortDuplicate={'INCENTIVO_CODE'}
            downTemplate={{
              fileNameDown: `${moment(cuota?.valueSearch?.periodo).format('YYYY-MM')}_Plantilla de mecanica venta`,
              fields: ['INCENTIVO_CODE','MECANICA','DIA_CORTE']
            }}
          />
        </span>
        {dataImport?.success && (
          <p style={{ color: '#07c107', marginTop: '10px', fontSize: '14px' }}>
            Archivo importado: {dataImport.nameFile}
          </p>
        )}
        {dataChanging.tipo_incentivo_id ? (
          <>
            <TextField
              label="Mecanica"
              fullWidth
              type="text"
              name="mecanica"
              margin="normal"
              value={dataChanging.mecanica || ''}
              onChange={(e) => handleChange('mecanica', e.target.value)}
              required
            />
            <TextField
              label="Fecha de corte"
              fullWidth
              type="date"
              name="fec_corte"
              margin="normal"
              value={dataChanging.fec_corte || ''}
              onChange={(e) => handleChange('fec_corte', e.target.value)}
              InputLabelProps={{
                shrink: true
              }}
              required
            />
            {/* <FormControl fullWidth margin="normal" size="small">
                <InputLabel>Fecha de corte</InputLabel>
                <Select
                    value={dataChanging.fec_corte || ''}
                    onChange={(e) => handleChange('fec_corte', e.target.value)}
                    label="Fecha de corte"
                >
                    <MenuItem value={`${moment().format("YYYY-MM")}-15`}>
                        15 de {moment().format("MMMM")} del {moment().format("YYYY")}
                    </MenuItem>
                    <MenuItem value={`${moment().format("YYYY-MM")}-30`}>
                        30 de {moment().format("MMMM")} del {moment().format("YYYY")}
                    </MenuItem>
                </Select>
            </FormControl> */}
          </>
        ) : undefined}
      </Modal>
    </>
  );
});
